import { classNames } from '../App'
import TrendArrowDownIcon from '../icons/trendarrowdown'
import TrendArrowUpIcon from '../icons/trendarrowup'
import CountUp from 'react-countup'
import { motion } from "framer-motion";

export default function HRDashboardCard({ title, value, comparedToText, comparedToType, showIcon = false }) {

    return (
        <div className="stat">
            <div className="stat-title">{title}</div>
            <div className="stat-value">
                <CountUp start={0} end={value} duration={1.5} separator=',' />
                {/* {value} */}
            </div>
            <motion.div
                layout
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="stat-desc"
            >
                <span
                    className={classNames(
                        comparedToType == 'up' && 'text-accent_green',
                        comparedToType == 'down' && 'text-tertiary',
                        'flex flex-row gap-1 stat-desc'
                    )}
                >
                    {showIcon && comparedToType == 'up' && (
                        <TrendArrowUpIcon className="size-4" />
                    )}
                    {showIcon && comparedToType == 'down' && (
                        <TrendArrowDownIcon className="size-4 mt-[0.1rem]" />
                    )}
                    {comparedToText}
                </span>
            </motion.div>
        </div>
    )
}